export default __webpack_public_path__ + "static/media/logo_head_white.eda0b71f.png";